// extracted by mini-css-extract-plugin
module.exports = {"colorInput":"ColorInput_colorInput__2bVke","input":"ColorInput_input__2FqWN","colorPreview":"ColorInput_colorPreview__Kb2aD"};